(function(){
var KIOSK=/[?&]kiosk=1/.test(location.search);
if(KIOSK)document.body.classList.add("mdw-kiosk");
var COMPANY="VxwBDp",LIST="RjaR8x",SMS_LIST="UGdqsv",REV="2024-10-15";
var TYPOS={"gamil.com":"gmail.com","gmial.com":"gmail.com","gmali.com":"gmail.com","gmail.con":"gmail.com","hotmial.com":"hotmail.com","hotmali.com":"hotmail.com","outlok.com":"outlook.com","yaho.com":"yahoo.com","yahooo.com":"yahoo.com","icloud.con":"icloud.com"};
var em=document.getElementById("mdw-email"),hint=document.getElementById("mdw-emailhint");
em.addEventListener("input",function(){var d=em.value.trim().toLowerCase().split("@")[1]||"";hint.textContent=TYPOS[d]?("Did you mean @"+TYPOS[d]+"?"):"";});
var po=document.getElementById("mdw-postal");
po.addEventListener("input",function(){var v=po.value.toUpperCase().replace(/[^A-Z0-9]/g,"").slice(0,6);po.value=v.length>3?(v.slice(0,3)+" "+v.slice(3)):v;});
document.getElementById("mdw-pills").addEventListener("change",function(){
 var ls=document.querySelectorAll("#mdw-pills label");
 for(var i=0;i!==ls.length;i++){ls[i].className=ls[i].querySelector("input").checked?"mdw-on":"";}
});
function kpost(path,payload){
 return fetch("https://a.klaviyo.com/client/"+path+"/?company_id="+COMPANY,{method:"POST",headers:{"Content-Type":"application/json","revision":REV},body:JSON.stringify(payload)});
}
document.getElementById("mdw-form").addEventListener("submit",function(e){
 e.preventDefault();
 var err=document.getElementById("mdw-err");err.textContent="";
 if(document.getElementById("mdw-company").value){showThanks("");return;}
 var first=document.getElementById("mdw-first").value.trim(),last=document.getElementById("mdw-last").value.trim();
 var mob=document.getElementById("mdw-mobile").value.trim(),mail=em.value.trim().toLowerCase();
 var digits=mob.replace(/\D/g,"");if(digits.length===11&&digits.charAt(0)==="1")digits=digits.slice(1);
 if(!first){err.textContent="Your first name, please.";return;}
 if(mail&&!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mail)){err.textContent="That email does not look quite right.";return;}
 if(mob&&digits.length!==10){err.textContent="That mobile number does not look quite right.";return;}
 if(!mail&&digits.length!==10){err.textContent="An email or a mobile number, whichever you prefer.";return;}
 var postal=po.value.trim();
 if(postal&&!/^[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9]$/.test(postal)){err.textContent="That postal code does not look quite right.";return;}
 var pref=document.querySelector('input[name="mdw-pref"]:checked');
 var optin=document.getElementById("mdw-optin").checked;
 var attrs={first_name:first,last_name:last,
  location:{address1:document.getElementById("mdw-addr").value.trim(),city:document.getElementById("mdw-city").value.trim(),region:document.getElementById("mdw-prov").value,zip:postal,country:"Canada"},
  properties:{source:"instore-form",preferred_contact:pref?pref.value:"email",marketing_opt_in:optin,loyalty_interest:document.getElementById("mdw-loyal").checked,associate:document.getElementById("mdw-staff").value,mobile_raw:mob,captured_at:new Date().toISOString()}};
 if(mail)attrs.email=mail;
 if(digits.length===10)attrs.phone_number="+1"+digits;
 var btn=document.getElementById("mdw-go");btn.disabled=true;btn.textContent="One moment...";
 kpost("profiles",{data:{type:"profile",attributes:attrs}}).then(function(r){
  if(r.status!==202&&!r.ok)throw new Error("profile "+r.status);
 var smsOn=document.getElementById("mdw-sms")&&document.getElementById("mdw-sms").checked;
 if(smsOn&&digits.length===10){
  kpost("subscriptions",{data:{type:"subscription",attributes:{custom_source:"Mr. Derk in-store client form (SMS)",profile:{data:{type:"profile",attributes:{phone_number:"+1"+digits,first_name:first,last_name:last,subscriptions:{sms:{marketing:{consent:"SUBSCRIBED"}}}}}}},relationships:{list:{data:{type:"list",id:SMS_LIST}}}}}).catch(function(){});
 }
  if(optin&&mail){
   return kpost("subscriptions",{data:{type:"subscription",attributes:{custom_source:"Mr. Derk in-store client form",profile:{data:{type:"profile",attributes:{email:mail,first_name:first,last_name:last}}}},relationships:{list:{data:{type:"list",id:LIST}}}}});
  }
 }).then(function(){
  btn.disabled=false;btn.textContent="All set";
  showThanks(first);
 }).catch(function(){
  btn.disabled=false;btn.textContent="All set";
  err.textContent="Could not save just now. Give it another go, or tell your associate.";
 });
});
function showThanks(first){
 document.getElementById("mdw-card").style.display="none";
 var t=document.getElementById("mdw-thanks");t.style.display="block";
 if(first){document.getElementById("mdw-tname").textContent=first;document.getElementById("mdw-tnamewrap").style.display="";}
 else{document.getElementById("mdw-tnamewrap").style.display="none";}
 if(KIOSK){setTimeout(function(){document.getElementById("mdw-form").reset();hint.textContent="";document.getElementById("mdw-city").value="Edmonton";t.style.display="none";document.getElementById("mdw-card").style.display="block";},5000);}
}

// --- Defensive popup remover (Klaviyo popups + chat widgets) — runs on load + periodically ---
function mdwKillPopups(){
 var kills=document.querySelectorAll('.klaviyo-form-container, [class*="klaviyo-form"], form[action*="newsletter"], .newsletter-form, .footer-newsletter, .fixed.bottom-0.left-0, shopify-chat, #shopify-chat');
 for(var k=0;k!==kills.length;k++){try{kills[k].remove();}catch(e){}}
}
mdwKillPopups();
setInterval(mdwKillPopups,1500);
})();